module.exports = __webpack_public_path__ + "static/img/p_service.9b1bacd6.png";